export default {"bookie-logo":"ne0NW","no-padding":"B1C4e"};